import * as Dati from './Dati';
import * as Data from './Data';
import * as Glob from './Globale';

export class CDatiFideValutazione {
    ID_FideValutazione: number = 0;
    ID_DatoEconomico: number = 0;
    ID_AnagDa: number = 0;
    ID_AnagA: number = 0;
    ImportoAffidamento: number = 0;
    PatrimonioNetto: number = 0;
    MargineOperativo: number = 0;
    CalcolatoRedditivita: number = 0;
    AttivoCircolante: number = 0;
    DebitiBreve: number = 0;
    TotalePassivo: number = 0;
    ValoreProduzione: number = 0;
    ValoreProduzionePrecedente: number = 0;
    CalcolatoAndamento: number = 0;
    ID_Utente: number = 0;
    ID_TipoValutazioneEsito: string = "";
    TipoValutazioneEsito: string = "";
    Utente: string = "";
    ID_FideAffidamento: number = 0;
    Data: Date = new Date(Date.now());
    Note: string = "";
}

export class CDatiFideAffidamentoLimite {
    ID_FideAffidamento: number = 0;
    LimiteMassimoContraente: number = 0;
    LimiteMassimoContraente_Provvisorie: number = 0;
    LimiteMassimoContraente_NonProvvisorie: number = 0;
    LimiteMassimoContraenteUtilizzato: number = 0;
    LimiteMassimoContraenteUtilizzato_Provvisorie: number = 0;
    LimiteMassimoContraenteUtilizzato_NonProvvisorie: number = 0;
}

export class CDatiFideAffidamentoLimiteCapogruppo extends CDatiFideAffidamentoLimite {
    Denominazione: string = "";
}

export class CDatiFideAffidamento {
    ID_TipiRamo: number = 0; //TODO Serve?
    ID_TipoProdotto: number = 0; //TODO Serve?
    ID_FideAffidamento: number = 0;
    ID_AnagDa: number = 0;
    ID_AnagA: number = 0;
    LimiteMassimoContraente: number = 0;
    LimiteMassimoFideiussione: number = 0;
    LimiteMassimoFideiussioneAutonomiaPOS: number = 0;
    LimiteMassimoContraente_Provvisorie: number = 0;
    LimiteMassimoFideiussione_Provvisorie: number = 0;
    LimiteMassimoFideiussioneAutonomiaPOS_Provvisorie: number = 0;
    LimiteMassimoContraente_NonProvvisorie: number = 0;
    LimiteMassimoFideiussione_NonProvvisorie: number = 0;
    LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorie: number = 0;
    ScadenzaAffidamento: Date = (new Data.CData(undefined, true)).AddAnni(1).Data;
    ID_UtenteSottoscrittore: number = 0;
    Note: string = "";
    Data: Date = new Date(Date.now());
    //Importo: number = 0;
    AnagA: string = "";
    AnagDa: string = "";
    UtenteSottoscrittore: string = "";
    Esito: string = "";
    ID_TipoFideAffidamento: string = Glob.Tipi_FA_Affidamento;
    ID_TipoFideAffidamentoEsito: string = "";
    ID_TipoSOA: string = "";
    ListaFideAffidamentoApprovazioneJSON: Glob.DatiJSON = "[]";
    ListaBinderJSON: Glob.DatiJSON = "[]";
    RigaInizio: Date = new Date();
}

export class CDatiFideTassi {
    Compagnia: string = "";
    ID_FideTassoRiga: number = 0;
    ID_Binder: number = 0;
    ID_BinderCompagnia: number = 0;
    ID_TipoRamo: number = 0;
    ID_TipoProdotto: number = 0;
    ID_TipoDurata: string = "";
    Durata: number = 0;
    TassoMin: number = 0;
    SommaGarantitaDa: number = 0;
    SommaGarantitaA: number = 0;
    PremioFisso: number = 0;
    TipoRamo: string = "";
    TipoProdotto: string = "";
    LimitePerSingoloProdotto: number = 0;
    LimiteTassoMinimo: number = 0;

    constructor(compagnia: string, id_Binder: number, id_BinderCompagnia: number, id_TipoRamo: number, id_TipoProdotto: number, id_TipoDurata: string, durata: number, tipoRamo: string, tipoProdotto: string, limitePerSingoloProdotto: number, limiteTassoMinimo: number, sommaGarantitaDa: number, sommaGarantitaA: number) {
        this.Compagnia = compagnia;
        this.ID_Binder = id_Binder;
        this.ID_BinderCompagnia = id_BinderCompagnia;
        this.ID_TipoRamo = id_TipoRamo;
        this.ID_TipoProdotto = id_TipoProdotto;
        this.ID_TipoDurata = id_TipoDurata;
        this.Durata = durata;
        this.TipoRamo = tipoRamo;
        this.TipoProdotto = tipoProdotto;
        this.LimitePerSingoloProdotto = limitePerSingoloProdotto;
        this.LimiteTassoMinimo = limiteTassoMinimo;
        this.SommaGarantitaDa = sommaGarantitaDa;
        this.SommaGarantitaA = sommaGarantitaA;
        this.TassoMin = limiteTassoMinimo;
    }
}

export type CRisAPIListaLimitiFideAffidamento = Dati.CRisAPIDato<CDatiFideAffidamentoLimite>;
export type CRisAPIListaLimitiFideAffidamentoCapogruppo = Dati.CRisAPILista<CDatiFideAffidamentoLimiteCapogruppo>;

export class CDatiFideCoobbligato {
    ID_FideCoobligato: number = 0;
    ID_FideAffidamento?: number = undefined;
    ID_Polizza?: number = undefined;
    ID_Anag: number = 0;
    ID_TipoAnagPrincipale: string = "";
    Quota: number = 0;
}

export class CDatiFideCoobbligatoExtra {
    Importo: number = 0;
    CoAssicurazioneJSON: string = "[]";
}

export class CRisAPIPagineTipi_FideValutazione extends Dati.CRisAPIPagineTipi<CDatiFideValutazione>{
    constructor() {
        super();
        this.Dati = [];
        this.Tipi = {};
    }
}

export class CRisAPIPagineTipi_FideAffidamento extends Dati.CRisAPIPagineTipi<CDatiFideAffidamento>{
    constructor() {
        super();
        this.Dati = [];
        this.Tipi = {};
    }
}

export class CRisAPITipi_FideAffidamento extends Dati.CRisAPIListaTipi<CDatiFideAffidamento>{
    constructor() {
        super();
        this.Dati = [];
        this.Tipi = {};
    }
}

//export class CRisAPIPagineFidePolizza extends Dati.CRisAPIPagine<CDatiFidePolizza>{
//    constructor() {
//        super();
//        this.Dati = [];
//    }
//}

export class CRisAPIDatoTipi_FideAffidamento extends Dati.CRisAPIDatoTipi<CDatiFideAffidamento>{
    constructor() {
        super();
        this.Dato = new CDatiFideAffidamento();
        this.Tipi = {};
    }
}

//export class CRisAPIDatoFidePolizza extends Dati.CRisAPIDato<CDatiFidePolizza>{
//    constructor() {
//        super();
//        this.Dato = new CDatiFidePolizza();
//    }
//}

export class CRisAPIDatoTipi_FideValutazione extends Dati.CRisAPIDatoTipi<CDatiFideValutazione>{
    constructor() {
        super();
        this.Dato = new CDatiFideValutazione();
        this.Tipi = {};
    }
}

export class CRisAPIDatoFideTassi extends Dati.CRisAPIDato<CDatiFideTassi>{
    constructor() {
        super();
        this.Dato = new CDatiFideTassi("", 0, 0, 0, 0, "", 0, "", "", 0, 0, 0, 0);
    }
}

export class CRisAPIListaFideTassi extends Dati.CRisAPIListaTipi<CDatiFideTassi>{
    constructor() {
        super();
        this.Dati = [];
        this.Tipi = {};
    }
}

export class CRisAPILista_FideCoobbligato extends Dati.CRisAPIExtra<Dati.CRisAPILista<CDatiFideCoobbligato>, CDatiFideCoobbligatoExtra>{
    constructor() {
        super();
        this.RisAPI = new Dati.CRisAPILista<CDatiFideCoobbligato>();
        this.RisAPI.Dati = [];
        this.Extra = new CDatiFideCoobbligatoExtra();
    }
}



// WEBPACK FOOTER //
// ./src/DatiFide.tsx